export default __webpack_public_path__ + "static/site-app-dark-mode-8bfd8e9106a5c3c48a5c900eeaa506be.png";